import React, { Fragment } from "react";
import "./Reveal.css";

/** Times in ms, distances in px. */
export interface RevealWordsTiming {
  start: number;
  stagger: number;
  duration: number;
  rise: number;
  blur: number;
}

/** One element's entrance (ms), for the reveal-fade and reveal-draw-down classes. */
export interface RevealTiming {
  start: number;
  duration: number;
}

export const words = (start: number, stagger: number, duration: number, rise: number, blur: number): RevealWordsTiming => ({
  start,
  stagger,
  duration,
  rise,
  blur,
});

export const revealStyle = ({ start, duration }: RevealTiming): React.CSSProperties =>
  ({ "--reveal-delay": `${start}ms`, "--reveal-duration": `${duration}ms` }) as React.CSSProperties;

interface RevealWordsProps {
  text: string;
  timing: RevealWordsTiming;
  /** Per word, e.g. a gradient text fill: a moving word cannot share its parent's background clip. */
  wordStyle?: React.CSSProperties;
}

const RevealWords: React.FC<RevealWordsProps> = ({ text, timing, wordStyle }) => (
  <>
    {text.split(" ").map((word, i) => (
      <Fragment key={i}>
        {i > 0 && " "}
        <span
          className="reveal-word"
          style={
            {
              ...wordStyle,
              "--reveal-delay": `${Math.round(timing.start + i * timing.stagger)}ms`,
              "--reveal-duration": `${timing.duration}ms`,
              "--reveal-rise": `${timing.rise}px`,
              "--reveal-blur": `${timing.blur}px`,
            } as React.CSSProperties
          }
        >
          {word}
        </span>
      </Fragment>
    ))}
  </>
);

export default RevealWords;
